export * from './id';
export * from './color-sets';
export * from './sort';
export * from './throttle';
export * from './color-utils';
export * from './visibility-observer';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/release/utils/index.js
// module id = 850
// module chunks = 3